import { useState, useEffect } from 'react';

export const useMenuPosition = (anchorEl, isMobile, subMenuOpen, firstMenuRef) => {
  const [menuPos, setMenuPos] = useState({ left: 0, top: 0 });
  const [subMenuPos, setSubMenuPos] = useState({ left: 0, top: 0 });

  // 1차 메뉴 위치 계산
  useEffect(() => {
    if (anchorEl) {
      const rect = anchorEl.getBoundingClientRect();
      
      if (isMobile) {
        // 모바일: 1차 메뉴를 아래로, 화면 오른쪽 끝에서 안전한 거리 확보
        const menuWidth = 180;
        const screenWidth = window.innerWidth;
        const safeLeft = Math.min(rect.left, screenWidth - menuWidth - 16); // 16px 여백
        
        setMenuPos({
          left: safeLeft + window.scrollX,
          top: rect.bottom + window.scrollY + 4,
        });
      } else {
        // 데스크톱: 기존 방식 (오른쪽으로)
        setMenuPos({
          left: rect.right + window.scrollX,
          top: rect.top + window.scrollY,
        });
      }
      
      // 다른 메뉴들 자동 닫기 (DOM에서 직접 찾아서 닫기)
      const projectMenus = document.querySelectorAll('[data-menu-type="project"]');
      projectMenus.forEach(menu => {
        if (menu.style.display !== 'none') {
          menu.style.display = 'none';
        }
      });
    }
  }, [anchorEl, isMobile]);

  // 2차 메뉴 위치 계산
  useEffect(() => {
    if (subMenuOpen && firstMenuRef.current) {
      const rect = firstMenuRef.current.getBoundingClientRect();
      
      if (isMobile) {
        // 모바일: 2차 메뉴를 왼쪽으로
        setSubMenuPos({
          left: rect.left + window.scrollX - 180, // 메뉴 너비만큼 왼쪽으로
          top: rect.top + window.scrollY,
        });
      } else {
        // 데스크톱: 기존 방식 (오른쪽으로)
        setSubMenuPos({
          left: rect.right + window.scrollX,
          top: rect.top + window.scrollY,
        });
      }
    }
  }, [subMenuOpen, isMobile]);

  return { menuPos, subMenuPos };
}; 